<app-header></app-header>

<div class="middle-content-wrap">
    <div class="globalheading" style="display: flex; justify-content: space-between; align-items: center;">
        <div>
            <h2>Least Valuable Members</h2>
            <p style="margin: 0; font-size: 14px; color: #666;">These are verified users with low activity or low
                attractiveness and they never went on a date and they have
                no active subscription (paid or scouted)</p>
        </div>
        <button class="export-btn" (click)="openExportModal()">
            <img src="assets/images/export.svg" alt="" /> Export
        </button>
        <button class="btn btn-danger" [disabled]="selectedUserIds.size === 0" data-toggle="modal"
            data-target="#archiveModal">
            Archive Users
        </button>
    </div>

    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" [checked]="isAllSelected" (change)="toggleAllSelection()">
                        </th>
                        <th>Image</th>
                        <th>User ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Tier ID</th>
                        <th>Gender</th>
                        <th>Age</th>
                        <th>Nationality</th>
                        <th>Occupation</th>
                        <th>Activity Score</th>
                        <th>Attractiveness Score</th>
                        <th>Likes Received</th>
                        <th>Passes Received</th>
                        <th>Likes Sent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of userList | paginate: { itemsPerPage: itemsPerPage, currentPage: p, totalItems: total }"
                        style="cursor:pointer">
                        <td>
                            <input type="checkbox" [checked]="selectedUserIds.has(user.user_id)"
                                (change)="toggleSelection(user.user_id)">
                        </td>
                        <td (click)="goToCustomerDetail(user.user_id)">
                            <div class="profile-image" *ngIf="user.profile_image">
                                <img [src]="user.profile_image" alt="Profile" class="user-avatar"
                                    style="width: 50px; height: 50px; object-fit: cover; border-radius: 50%;">
                            </div>
                            <div class="profile-image" *ngIf="!user.profile_image">
                                <div style="width: 50px; height: 50px; background-color: #ccc; border-radius: 50%;">
                                </div>
                            </div>
                        </td>
                        <td>{{ user.user_id }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.tier_id }}</td>
                        <td>{{ user.gender }}</td>
                        <td>{{ calculateAge(user.dateOfBirth) }}</td>
                        <td>{{ user.nationality }}</td>
                        <td>{{ user.occupation }}</td>
                        <td>{{ user.activity_score }}</td>
                        <td>{{ user.attractiveness_score }}</td>
                        <td>{{ user.likes_received }}</td>
                        <td>{{ user.passes_received }}</td>
                        <td>{{ user.likes_sent }}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="userList?.length == 0">
                    <tr>
                        <td colspan="15" class="text-center">No data found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
            </div>
        </div>
    </div>
</div>

<!-- Archive Confirmation Modal -->
<div class="modal fade" id="archiveModal" tabindex="-1" role="dialog" aria-labelledby="archiveModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="archiveModalLabel">Confirm Archive</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure to archive {{ selectedUserIds.size }} users?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    id="closeArchiveModal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="bulkArchiveUsers()">Yes, Archive</button>
            </div>
        </div>
    </div>
</div>


<!-- Export Modal -->
<div class="modal fade bd-example-modal-lg common_modal" id="exportModal" tabindex="-1" role="dialog"
    aria-labelledby="exportModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Export Data
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p>Select the fields you want to include in the export:</p>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-check mb-2" *ngFor="let field of availableExportFields; let i = index">
                                <input class="form-check-input" type="checkbox" [id]="'exportField_' + field.key"
                                    [checked]="selectedExportFields.includes(field.key)"
                                    (change)="toggleExportField(field.key)">
                                <label class="form-check-label" [for]="'exportField_' + field.key">
                                    {{ field.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <button type="button" class="btn btn-sm btn-secondary" (click)="selectAllExportFields()">
                            Select All
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
                            (click)="clearAllExportFields()">
                            Clear All
                        </button>
                    </div>
                    <div class="common_btn mt-4">
                        <button data-dismiss="modal">Cancel</button>
                        <button style="width: auto;" (click)="exportWithSelectedFields()"
                            [disabled]="selectedExportFields.length === 0">
                            Export ({{ selectedExportFields.length }} fields)
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>